import { render, staticRenderFns } from "./AutorizarSalidaExtraForm.vue?vue&type=template&id=4836053d&"
import script from "./AutorizarSalidaExtraForm.vue?vue&type=script&lang=js&"
export * from "./AutorizarSalidaExtraForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports